<!-- CẤU HÌNH GIAO DIỆN -->
<div class="editor">
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing"></app-width-height-config>
    <!-- LOẠI HÌNH DẠNG -->
    <ul nz-menu nzMode="inline" nzInlineCollapsed="false">
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>

        <div *ngIf="device == 'desktop'" class="mb-4" style="white-space: nowrap;height: 10px;">
          <p class="m-0">Ẩn ở trang Mobile <span style="font-size: 13px;">(khi xem bản Live)</span></p>
          <nz-switch [(ngModel)]="staticdata.mobile_portrait_hidden"
            (ngModelChange)="updateHiiden({mobile_portrait_hidden : $event})"></nz-switch>
        </div>
        <div *ngIf="device == 'mobile_portrait'" class="mb-4" style="white-space: nowrap;height: 10px;">
          <p class="m-0">Ẩn ở trang Desktop <span style="font-size: 13px;">(khi xem bản Live)</span></p>
          <nz-switch [(ngModel)]="staticdata.desktop_hidden"
            (ngModelChange)="updateHiiden({desktop_hidden : $event})"></nz-switch>
        </div>
      </li>
      <!-- CHỌN KIỂU -->
      <li nz-submenu nzTitle="{{'chon_kieu' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class=" mt-2">
          <div class="rate-template" [ngClass]="staticdata[device + '_format_rate'].rate_type == 'star' ? 'active' : ''"
            (click)="chooseType('star',0)">
            <div class="rating">
              <span *ngFor="let item of listIcon"><i class="bi bi-star-fill"></i></span>
            </div>
          </div>
          <div class="rate-template"
            [ngClass]="staticdata[device + '_format_rate'].rate_type == 'emoji' ? 'active' : ''"
            (click)="chooseType('emoji',1)">
            <div class="rating">
              <span><i class="bi bi-emoji-frown"></i></span>
              <span><i class="bi bi-emoji-frown"></i></span>
              <span><i class="bi bi-emoji-neutral"></i></span>
              <span><i class="bi bi-emoji-smile"></i></span>
              <span><i class="bi bi-emoji-smile"></i></span>
            </div>
          </div>
          <div class="rate-template"
            [ngClass]="staticdata[device + '_format_rate'].rate_type == 'heart' ? 'active' : ''"
            (click)="chooseType('heart',2)">
            <div class="rating">
              <span *ngFor="let item of listIcon"><i class="bi bi-heart-fill"></i></span>
            </div>
          </div>
        </div>
      </li>
      <!-- CẤU HÌNH -->
      <li nz-submenu nzTitle="{{'cau_hinh' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <div class="">
          <div class="config-name mt-2">
            <p class="m-0">{{'kich_thuoc' | translate}}</p>
            <nz-input-number [ngModel]="class['rate-content__container--span']['font-size'] | vhnumber" [nzMin]="1"
              [nzMax]="100" [nzStep]="1" style="width: 40%;" (nzBlur)="updateClass()" (ngModelChange)="
            class['rate-content__container--span']['font-size'] =
              $event + 'px'"></nz-input-number>
          </div>
          <nz-slider [ngModel]="class['rate-content__container--span']['font-size'] | vhnumber" [nzMin]="1"
            [nzMax]="100" [nzStep]="1" style="width: 40%;" (nzBlur)="updateClass()" (ngModelChange)="
          class['rate-content__container--span']['font-size'] =
            $event + 'px'"></nz-slider>
        </div>
        <div class="">
          <div class="config-name mt-2">
            <p class="m-0">{{'khoang_cach' | translate}}</p>
            <nz-input-number [ngModel]="class['rate-content__container']['gap'] | vhnumber" [nzMin]="1" [nzMax]="100"
              [nzStep]="1" style="width: 40%;" (nzBlur)="updateClass()" (ngModelChange)="
          class['rate-content__container']['gap'] =
            $event + 'px'"></nz-input-number>
          </div>
          <nz-slider [ngModel]="class['rate-content__container']['gap'] | vhnumber" [nzMin]="1" [nzMax]="100"
            [nzStep]="1" style="width: 40%;" (nzBlur)="updateClass()" (ngModelChange)="
        class['rate-content__container']['gap'] =
          $event + 'px'"></nz-slider>
        </div>
        <div class="config-name mt-4" style="flex-wrap: wrap;">
          <p classs="w-50">{{'mau_cac_icon_chua_chon' | translate}}</p>
          <input type="button" [cpOKButton]="true" [(colorPicker)]="class['rate-content__container--icon']['color']"
            [style.background]="class['rate-content__container--icon']['color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [style.height]="'20px'" [cpPositionRelativeToArrow]="true" />
        </div>
        <div class="config-name mt-4" style="flex-wrap: wrap;">
          <p classs="w-50">{{'mau_cac_icon_da_chon' | translate}}</p>
          <input type="button" [cpOKButton]="true" [(colorPicker)]="class['rate-content__container--icon-active']['color']"
            [style.background]="class['rate-content__container--icon-active']['color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [style.height]="'20px'" [cpPositionRelativeToArrow]="true" />
        </div>
        <div class="config-name mt-4" style="flex-wrap: wrap;">
          <p classs="w-50">{{'mau_nen' | translate}}</p>
          <input type="button" [cpOKButton]="true" [(colorPicker)]="class['rate']['background-color']"
            [style.background]="class['rate']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [style.height]="'20px'" [cpPositionRelativeToArrow]="true" />
        </div>
      </li>
      <!-- KHOẢNG ĐỆM -->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['rate']" [paddingConfigs]="[{ type: 'top' }, { type: 'left' }, { type: 'bottom' }, { type: 'right' }]">
        </app-padding-config>
      </li>
      <!-- Viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['rate']" [id_object]="objectChoosing._id">
        </app-borders-config>
      </li>
      <!-- Bo góc -->
      <li nz-submenu nzTitle="{{'bo_goc' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderRadiusClass]="class['rate']" [id_object]="objectChoosing._id">
        </app-borders-radius-config>
      </li>
      <!-- Đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['rate']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
       <!-- <app-animations-config [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config> -->
    </div>
  </div>
</div>